<!-- 用於顯示紅色 * 告警提示星號 -->
<template>
  <small class="small-color">
    *{{ SmallText }}
  </small>
</template>

<script>
export default {
  props: {
    SmallText: {
      type: String,
      default: ''
    }
  }
}
</script>
